const courseRouter = [
  {
      path: "list-course",
      name: "course",
      component: () => import("@/views/admin/course"),
      default: true,
      meta: {
          model: "course",
          // requiresAuth: true,
      },
  },
  {
      path: "list-course/add",
      name: "addCourse",
      component: () => import("@/views/admin/course/function"),
      default: true,
      meta: {
          model: "course",
          // requiresAuth: true,
      },
  },
  {
      path: "list-course/edit/:id",
      name: "editCourse",
      component: () => import("@/views/admin/course/function"),
      default: true,
      meta: {
          model: "course",
          // requiresAuth: true,
      },
  },
  {
    path: "list-course/view/:id",
    name: "viewCourse",
    component: () => import("@/views/admin/course/view"),
    default: true,
    meta: {
        model: "course",
        // requiresAuth: true,
    },
  },
];
export default courseRouter;